import LogoText from "components/media/LogoWithText"
import Link from "next/link"

export default function JobHeader() {
  return (
    <div>
      <div className="bg-blue-600 mx-auto py-4">
        <div className="max-w-7xl mx-auto text-white text-2xl">
          <Link href="/careers">
            <LogoText
              color="white"
              className="ml-4 sm:ml-0 h-10 sm:h-14 w-auto inline"
            />{" "}
            <span className="px-3">| </span>Careers
          </Link>
        </div>
      </div>
    </div>
  )
}
